import http from './http';

export default {
  createTicket(data) {
    return http().post(`/v1/help/create_ticket`, data);
  },
  createFeatureRequest(data) {
    return http().post(`/v1/help/create_feature_request`, data);
  },
}
